import { Link } from 'react-router-dom';
import { COMICS } from '@/mocks/comics';
import SectionHeading from '@/components/base/SectionHeading';

function formatViews(n: number) {
  if (n >= 10000) return `${(n / 10000).toFixed(1).replace(/\.0$/, '')}万`;
  return `${n}`;
}

export default function DailyPick() {
  const pick = COMICS.find((c) => c.id === 3) ?? COMICS[0];
  return (
    <section className="bg-background-100 py-12 md:py-16">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <SectionHeading
          eyebrow="今日推荐"
          title="每日精选 · 一部值得入坑的作品"
          desc="每天一部编辑私心推荐，给你的追更列表加点新鲜灵感。"
          accent
        />
        <div className="mt-8 grid grid-cols-1 gap-6 rounded-2xl border border-background-200/70 bg-background-50 p-5 md:p-8 lg:grid-cols-2 lg:items-center">
          <div className="relative mx-auto w-full max-w-xs">
            <img
              src={pick.cover}
              alt={`${pick.title}今日推荐封面`}
              title={`${pick.title} · 漫画岛今日推荐`}
              loading="lazy"
              className="w-full rounded-xl object-cover object-top shadow-sm"
            />
            <span className="absolute -left-3 -top-3 flex h-16 w-16 items-center justify-center rounded-full bg-accent-500 text-sm font-bold text-background-50 shadow-sm">
              今日推荐
            </span>
          </div>
          <div>
            <div className="flex flex-wrap items-center gap-2">
              <span className="rounded-md bg-accent-100 px-2.5 py-1 text-xs font-bold text-accent-800">{pick.category}</span>
              <span className="rounded-md bg-secondary-100 px-2.5 py-1 text-xs font-bold text-secondary-800">{pick.status}</span>
              <span className="text-sm text-foreground-500">{pick.author}</span>
            </div>
            <h3 className="mt-3 font-heading text-3xl text-foreground-950 md:text-4xl">{pick.title}</h3>
            <p className="mt-3 text-base leading-relaxed text-foreground-700">{pick.short}</p>
            <div className="mt-4 flex flex-wrap gap-2">
              {pick.tags.map((t) => (
                <span key={t} className="rounded-full bg-background-100 px-3 py-1 text-xs text-foreground-600">
                  #{t}
                </span>
              ))}
            </div>
            <div className="mt-6 flex flex-wrap items-center gap-6 text-sm text-foreground-600">
              <span className="flex items-center gap-1.5">
                <i className="ri-star-fill text-accent-600"></i>
                <b className="text-foreground-950">{pick.rating}</b> 评分
              </span>
              <span className="flex items-center gap-1.5">
                <i className="ri-eye-line"></i>
                {formatViews(pick.views)} 阅读
              </span>
              <span className="flex items-center gap-1.5">
                <i className="ri-book-open-line"></i>
                {pick.chapterCount} 话
              </span>
            </div>
            <div className="mt-7 flex flex-col gap-3 sm:flex-row">
              <Link
                to={`/article/${pick.id}`}
                onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
                className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-full bg-primary-500 px-6 py-3 text-sm font-bold text-background-50 transition-colors hover:bg-primary-600"
              >
                <i className="ri-book-2-line text-base"></i>
                立即阅读
              </Link>
              <Link
                to={`/category/${pick.categorySlug}`}
                onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
                className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-full border border-background-200 bg-background-50 px-6 py-3 text-sm font-bold text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-600"
              >
                同类型推荐
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}